import React, { useEffect, useState } from "react";
import { ModalScreen } from "../../../components/ModalScreen";
import PlantillaScreen2 from "../../../helpers/PlantillaScreen2";
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";


export const ModalPanelControlSolicitud = ({
    open,
    setOpenSolicitud,
    loader,
    setLoader,
    folio,
    titulo,
    reiniciarPagina,
    setFiltroRazonSocial,
    setFiltroTipoSolicitud,
    setFiltroLineaCredito,
    setFiltroEstado,
    setFiltroSucursal,
    setFiltroVendedor,
    setFiltroFolio

}) => {
    const [condiciones, setCondiciones] = useState({});
    const [estatus, setEstatus] = useState("");
    const [openModal, setOpenModal] = useState(false); // Estado para controlar si el modal está abierto o cerrado
    const [selectedDate, setSelectedDate] = useState('');
    const [actionSelected, setActionSelected] = useState("");
    const [comentarios, setComentarios] = useState("");

  




    useEffect(() => {
        obtenerDatos()
    }, []);

    const obtenerDatos = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PanelControlSolicitudes/ObtenerEstado?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result.accion);
                const fechaSoloFecha = result.fecha_pagare.split('T')[0];
                setSelectedDate(fechaSoloFecha);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
            });
    }


    const onModalComentarios = (Accion) => {

        Swal.fire({
            title: `Agregar Comentario de ${Accion === "R" ? "Cancelación" : "Modificación"}`,
            input: "textarea",
            inputPlaceholder: "Escribe un comentario...",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Enviar",
            customClass: {
                confirmButton: Accion === "R" ? 'custom-confirm-button-cancel' : Accion === "A" ? "custom-confirm-button-active" : "custom-confirm-button-modify"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                onGuardar(result.value, Accion);
            }
        });
    };

    const onModalComentariosModificar = (Accion) => {

        Swal.fire({
            title: `Agregar Comentario de ${Accion === "R" ? "Cancelación" : "Modificación"}`,
            input: "textarea",
            inputPlaceholder: "Escribe un comentario...",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Enviar",
            customClass: {
                confirmButton: Accion === "R" ? 'custom-confirm-button-cancel' : Accion === "A" ? "custom-confirm-button-active" : "custom-confirm-button-modify"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                // onGuardar(result.value, Accion);
                handleClickOpen(result.value, Accion)
            }
        });
    };


    const onGuardar = (resultado, Accion) => {
        setLoader({ ...loader, mostrar: true });

        const comentarioAgregado = comentarios === "" || comentarios === null || comentarios === undefined ? resultado : comentarios

        if (
            comentarioAgregado === "" ||
            comentarioAgregado === undefined ||
            comentarioAgregado === null
        ) {
            Swal.fire(
                "Solicitud Credito",
                "Es necesario agregar comentarios de la razón",
                "warning"
            );
            setLoader({ ...loader, mostrar: false });
            return;
        }

        const post = {
            folio: folio,
            accion: Accion,
            comentarios: comentarioAgregado,
            fecha_pagare: selectedDate
        };
        request
            .post(`PanelControlSolicitudes`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
               
                Swal.fire("Solicitud Credito", result.mensaje, "success");
                setOpenSolicitud(false);
                reiniciarPagina()
                setFiltroRazonSocial([])
                setFiltroTipoSolicitud([])
                setFiltroLineaCredito([])
                setFiltroEstado([])
                setFiltroSucursal([])
                setFiltroVendedor([])
                setFiltroFolio([])
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };

    // Función para abrir el modal
    const handleClickOpen = (comentario, accion) => {
        setActionSelected(accion)
        setComentarios(comentario)
        setOpenModal(true);
    };

    // Función para cerrar el modal
    const handleClose = () => {
        setOpenModal(false);
    };

    // Función para manejar el cambio en el input de tipo date
    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    return (
        <ModalScreen close={setOpenSolicitud}>
            <span
                className="filtro-soy-span-close-comentarios"
                onClick={() => setOpenSolicitud(false)}
            >
                X
            </span>
            <PlantillaScreen2
                titulo={titulo}
                className={"asc-modal-comentarios-panel"}
                className_main={3}
            >
                <div className="modal-panel-control-main-container">
                    {estatus === "D" ? (
                        <div className="modal-panel-control-main-container-children">
                            <div className="panel-control-button-activar"
                                onClick={() => onModalComentarios("A")}
                            >
                                <div className="panel-control-button-activar-container"> <CheckCircleIcon />  Activar solicitud de credito</div>
                            </div>
                        </div>
                    ) : (
                        <div className="modal-panel-control-main-container-children">
                            <div className="panel-control-button-cancelar"
                                onClick={() => onModalComentarios("R")}
                            >
                                <div className="panel-control-button-cancelar-container"> <CancelIcon />  Cancelar solicitud de credito</div>
                            </div>
                            <div className="panel-control-button-modificar"
                                onClick={() => onModalComentariosModificar("M")}
                            >
                                <div className="panel-control-button-modificar-container"> <WarningIcon /> Solicitar modificación de pedido</div>
                            </div>
                        </div>
                    )}
                </div>
            </PlantillaScreen2>
            {/* Modal usando el componente Dialog de MUI */}
            <Dialog open={openModal} onClose={handleClose}>
                <DialogTitle>Selecciona una fecha para el pagare</DialogTitle>
                <DialogContent>
                    {/* Input tipo date */}
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        style={{ width: '100%', height: '30px' }}
                    />
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {/* Botón de Cerrar alineado a la izquierda */}
                    <Button onClick={handleClose} color="primary" sx={{ alignSelf: 'flex-start' }}>
                        Cerrar
                    </Button>

                    {/* Botón de Guardar alineado a la derecha */}
                    <Button
                        onClick={() => onGuardar("", "M")}
                        color="primary"
                        sx={{ alignSelf: 'flex-end' }}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </ModalScreen >
    );
};
